import React, { useEffect } from "react";
import classNames from "classnames";
import { BtnUi, PreferencesNoticeUi } from "~/components";
import { BrightcoveVideoContainer } from "../VideoContainer";
import { useLayoutStore } from "~/store";
import styles from "./SurveyStart.module.css";
import logoImage from "~/assets/images/marriott-logo-reverse.png";

export const SurveyStart = ({ next, videoId }) => {
  const { isResetting, setShowHeader, setContentClassName } = useLayoutStore();

  useEffect(() => {
    if (isResetting) {
      return;
    }

    setShowHeader(false);
    setContentClassName(styles.container);
  }, [isResetting]);

  return (
    <div className={styles.container}>
      <div className={styles.survey}>
        <div className={styles.surveyLogoWrapper}>
          <img
            className={styles.surveyLogo}
            src={logoImage}
            alt="Marriott logo"
          />
        </div>
        <section className={styles.surveyBox}>
          <BrightcoveVideoContainer
            className={styles.surveyVideo}
            videoId={videoId}
          />
          <div className={styles.surveyInfo}>
            <div className={styles.surveyPassion}>
              Tap Into Your Travel Passions
            </div>
            <div className={styles.surveyText}>
              Give a thumbs up or down on interests
            </div>
            <BtnUi
              className={classNames(styles.surveyBtn, "custom_click_track")}
              data-custom_click_track_value="Video|Get Started|internal"
              onClick={next}
            >
              Get Started
            </BtnUi>
          </div>
        </section>
      </div>
      <PreferencesNoticeUi className={styles.notice} />
    </div>
  );
};
